export const T = {
  en_GB: {
    existingPortfolio: "Existing Portfolio",
    modifiedPortfolio: "Modified Portfolio",
    existingSavingsPlan: "Existing Savings Plan",
    modifiedSavingsPlan: "Modified Savings Plan",
  },
  nb_NO: {
    existingPortfolio: "Eksisterende portefølje",
    modifiedPortfolio: "Endret portefølje",
    existingSavingsPlan: "Eksisterende spareavtale",
    modifiedSavingsPlan: "Endret spareavtale",
  },
} as const;
